import { render, staticRenderFns } from "./AddDrugCategory.vue?vue&type=template&id=751fcc1a&scoped=true&"
import script from "./AddDrugCategory.vue?vue&type=script&lang=js&"
export * from "./AddDrugCategory.vue?vue&type=script&lang=js&"
import style0 from "./AddDrugCategory.vue?vue&type=style&index=0&id=751fcc1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751fcc1a",
  null
  
)

export default component.exports